import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBanner from '@/pages/home/components/HeroBanner';
import CategorySection from '@/pages/home/components/CategorySection';
import FeaturedGrid from '@/pages/home/components/FeaturedGrid';
import LatestSection from '@/pages/home/components/LatestSection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '天狼影院 - 高清免费在线观看',
            description: '天狼影院提供高清免费在线观看，即点即播不缓冲，流畅追剧看电影，涵盖最新电视剧、电影、综艺大全连播。',
            url: 'https://www.tianlangcinema.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '天狼影院',
              url: 'https://www.tianlangcinema.com',
            },
          }),
        }}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategorySection />
          <FeaturedGrid />
          <LatestSection />

          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-[1400px] mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
                  为什么选择天狼影院
                </h2>
                <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                  我们致力于为用户提供极致的在线观影体验
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
                {[
                  {
                    icon: 'ri-flashlight-fill',
                    title: '即点即播',
                    desc: '先进CDN加速技术，点击即可播放，无需漫长等待缓冲，享受流畅观影体验',
                  },
                  {
                    icon: 'ri-4k-fill',
                    title: '高清画质',
                    desc: '支持1080P至4K超高清画质，每一个画面都清晰细腻，还原影院级视觉享受',
                  },
                  {
                    icon: 'ri-global-fill',
                    title: '海量资源',
                    desc: '涵盖电影、电视剧、综艺、动漫、纪录片等数万部优质视频内容，持续更新',
                  },
                  {
                    icon: 'ri-device-line',
                    title: '多端同步',
                    desc: '支持电脑、平板、手机多设备无缝切换，随时随地追剧观影不间断',
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="text-center p-6 rounded-xl bg-background-50 border border-background-200"
                  >
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-4 rounded-full bg-accent-500/10 text-accent-500">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-[1400px] mx-auto">
              <div className="text-center mb-8">
                <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
                  常见问题
                </h2>
                <p className="text-sm text-foreground-600">关于天狼影院的常见疑问解答</p>
              </div>
              <div className="max-w-3xl mx-auto flex flex-col gap-3">
                {[
                  {
                    q: '天狼影院是否需要注册才能观看？',
                    a: '不需要。天狼影院所有视频内容均可免费在线观看，无需注册登录，打开网站即可即点即播，享受流畅的观影体验。',
                  },
                  {
                    q: '天狼影院支持哪些设备观看？',
                    a: '天狼影院全面支持电脑（Windows/Mac）、平板（iPad/Android）、手机（iOS/Android）等主流设备，适配各种屏幕尺寸，让您随时随地追剧看电影。',
                  },
                  {
                    q: '视频画质如何？观看会卡顿吗？',
                    a: '天狼影院提供1080P至4K超高清画质选项，采用全球CDN加速节点分发，确保即点即播不缓冲。实际观看体验取决于您的网络环境，建议使用WiFi或4G/5G网络获得最佳体验。',
                  },
                  {
                    q: '天狼影院的视频资源更新频率如何？',
                    a: '我们拥有专业的内容更新团队，热门电视剧和综艺节目通常在播出后2小时内完成更新上架。电影资源也会第一时间同步各大平台的更新进度，确保内容新鲜及时。',
                  },
                ].map((faq, index) => (
                  <details
                    key={index}
                    className="group bg-background-100 rounded-xl border border-background-200 overflow-hidden"
                  >
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                      <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                        {faq.q}
                      </span>
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500 group-open:rotate-180 transition-transform duration-200">
                        <i className="ri-arrow-down-s-line"></i>
                      </div>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {faq.a}
                      </p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}